export const affiliationAddressStyles = {
	affiliationClickTarget: {
		cursor: 'pointer'
	},
	affiliationNameColor: {
		color: 'primary.main'
	},
	linkWeight: {
		fontWeight: 400
	},
	addressInherit: {
		fontSize: 'inherit',
		lineHeight: 'inherit'
	}
};
